import { Chip, FormControlLabel, FormGroup, Grid, IconButton, Radio, RadioGroup, Slider } from "@mui/material";
import CloseIcon from "assets/CloseIcon";
import { ReactComponent as ScrollLeft } from "assets/ScrollLeft.svg";
import { ReactComponent as ScrollRight } from "assets/ScrollRight.svg";
import { librarySelectedTab, setLoadPages } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import MultipleSelectCheckmarks from "components/common/dropdowns/MultiSelect";
import ButtonLink from "components/common/Link";
import Typography from "components/common/Typography";
import { isEmpty, isNull } from "lodash";
import { useContext, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { showText } from "utils/CommonConstants";
import { converter_ArrayString } from "utils/CommonFunctions";
import { ON_BOARDING } from "utils/URLConstants";
import { fetchSuggestedPlansIdAsync } from "../library/SuggestedPlans/SuggestedPlans.slice";
import Mcqlist from "./Mcqlist";
import {
  setShowOnboardingWizard,
  setShowOnboardingWizardFromLibrary,
  updateOnboardingQueries
} from "./Onboarding.slice";

interface Props {
  currQues?: any;
  setAllAnswers?: any;
  allAnswers?: any;
  retakeWizard?: boolean;
}

function QnA(props: Props) {
  const { currQues, setAllAnswers, allAnswers, retakeWizard = false } = props;
  const [checkBoxList, setCheckBoxList] = useState([]);
  const onboardingDetails: any = useAppSelector((state) => state.onboardingResponse.onboardingResponse);
  const innCode = useAppSelector((state) => state.app.innCode);

  const [selectedFilterMcqList, setSelectedFilterMcqList] = useState([]);
  const [checkMcqList, setCheckMcqList] = useState<any>();
  const [selectedMcqList, setSelectedMcqList] = useState<any>([]);
  const [showValue, setShowValue] = useState(false);
  const [showArrowMcq, setShowArrowMcq] = useState({
    left: false,
    right: false
  });
  const [showArrowFilterMcq, setShowArrowFilterMcq] = useState({
    left: false,
    right: false
  });
  const offsetRef = useRef<any>(null);
  const { isMobileScreen } = useContext(ThemeContext);
  const selectedTab = useAppSelector((state) => state.app.selectedTab);
  const dispatch = useAppDispatch();

  const checkButtons = (setShowButton: any) => {
    if (offsetRef.current) {
      const { scrollLeft, offsetWidth, scrollWidth } = offsetRef.current;

      if (scrollWidth > offsetWidth) {
        setShowButton((prev: any) => {
          return { ...prev, right: true };
        });
      }
      if (scrollLeft > 0) {
        setShowButton((prev: any) => {
          return { ...prev, left: true };
        });
      }
      if (Math.ceil(scrollLeft + offsetWidth) >= scrollWidth) {
        setShowButton((prev: any) => {
          return { ...prev, right: false };
        });
      }
      if (scrollLeft + offsetWidth < scrollWidth) {
        setShowButton((prev: any) => {
          return { ...prev, right: true };
        });
      }

      if (scrollLeft == 0) {
        setShowButton((prev: any) => {
          return { ...prev, left: false };
        });
      }
      if (scrollWidth === offsetWidth) {
        setShowButton((prev: any) => {
          return { ...prev, left: false, right: false };
        });
      }
    }
  };

  useEffect(() => {
    if (
      currQues.questionType === "SINGLE_CHOICE" ||
      currQues.questionType === "TEXT" ||
      currQues.questionType === "SCALE"
    ) {
      currQues.options.forEach((item: any) => {
        if (item.isSelected === "Y") {
          setAllAnswers({
            [currQues.quesId]: item.selectedValue,
            ...allAnswers
          });
        }
      });
    } else if (currQues.questionType === "MCQ") {
      setCheckMcqList(currQues?.options);

      setAllAnswers({
        [currQues.quesId]: [],
        ...allAnswers
      });
    } else if (currQues.questionType === "FILTER_MCQ") {
      setCheckBoxList(currQues?.options);
      const newArr: any = [];
      currQues.options.forEach((item: any) => {
        if (item.isSelected === "Y") {
          newArr.push(item.selectedValue);
        }
      });
      setAllAnswers({
        [currQues.quesId]: newArr,
        ...allAnswers
      });
    }
  }, [currQues]);

  const handleChange = (event: any) => {
    if (
      currQues.questionType === "SINGLE_CHOICE" ||
      currQues.questionType === "TEXT" ||
      currQues.questionType === "SCALE"
    ) {
      setAllAnswers({
        ...allAnswers,
        [currQues.quesId]: event.target.value
      });
    } else if (currQues.questionType === "MCQ") {
      let { value } = event.target;

      setAllAnswers({
        ...allAnswers,
        [currQues.quesId]: [...(allAnswers?.[currQues.quesId] || []), value]
      });
      let tempList: any = [...selectedMcqList];
      tempList.push(value);
      setSelectedMcqList(tempList);
      let updatedCheckList = currQues?.options?.filter(
        (value: any) => !tempList.includes(value?.answerOption) && !checkMcqList?.includes(value?.answerOption)
      );
      setCheckMcqList(updatedCheckList);
    } else if (currQues.questionType === "FILTER_MCQ") {
      let { value } = event.target;

      setAllAnswers({
        ...allAnswers,
        [currQues.quesId]: [...(allAnswers?.[currQues.quesId] || []), value]
      });
      let tempList: any = [...selectedFilterMcqList];
      tempList.push(value);
      setSelectedFilterMcqList(tempList);
    }
  };

  const optionAnswerJSX = (options: any) => {
    return (
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name={currQues.questionKey}
        value={allAnswers[currQues.quesId] || ""}
        onChange={handleChange}
      >
        {options.map((option: any) => {
          return (
            <FormControlLabel
              sx={{
                border: `1px solid ${tokens.Border.General.Tertiary}`,
                borderRadius: "8px",
                justifyContent: "space-between",
                paddingX: "16px",
                marginY: "4px",
                marginX: "0",
                width: "100%"
              }}
              key={option.answerOption}
              name="optionAns"
              value={option.answerOption}
              control={<Radio />}
              label={
                <Typography variant="body2" showBold>
                  {" "}
                  {option?.answerOption}
                </Typography>
              }
              labelPlacement="start"
            />
          );
        })}
      </RadioGroup>
    );
  };
  const filterList: any = (value: any) => {
    if (!isEmpty(value)) {
      let tempList = currQues?.options?.filter((option: any) => value.includes(option?.filterCategory));
      setCheckBoxList(tempList);
    } else {
      setCheckBoxList(currQues?.options);
    }
  };

  const getSelectedList: any = (list: any, setList: any) => {
    return list?.map((el: any) => {
      return (
        <>
          <Chip
            key={el}
            sx={{
              "&": { borderRadius: "50px", marginRight: "10px" },
              "& .MuiChip-deleteIcon": {
                color: `${tokens.Text.General.Color}`,
                marginRight: "10px"
              }
            }}
            label={el}
            onDelete={() => {
              let tempList = list?.filter((val: any) => el !== val);
              setList(tempList);
              setAllAnswers({
                ...allAnswers,
                [currQues.quesId]: allAnswers[currQues.quesId]?.filter((val: any) => el !== val)
              });
              let updatedCheckList = currQues?.options?.filter(
                (value: any) => !tempList.includes(value?.answerOption) && !checkMcqList?.includes(value?.answerOption)
              );
              setCheckMcqList(updatedCheckList);
            }}
          />
        </>
      );
    });
  };
  const onScrollHandle = (offset: any, setShowButton: any) => {
    if (offsetRef?.current) {
      offsetRef.current.scrollLeft += offset;
      checkButtons(setShowButton);
    }
  };
  useEffect(() => {
    if (offsetRef.current) {
      checkButtons(setShowArrowMcq);
    }
  }, [selectedMcqList]);
  useEffect(() => {
    if (offsetRef.current) {
      checkButtons(setShowArrowFilterMcq);
    }
  }, [selectedFilterMcqList]);
  const mcqAnswerJSX = () => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} maxWidth="300px" sx={{ display: "flex", flexWrap: "nowrap" }}>
          {showArrowMcq.left && (
            <IconButton size="small" sx={{ marginTop: "5px" }} onClick={() => onScrollHandle(-100, setShowArrowMcq)}>
              <ScrollLeft />
            </IconButton>
          )}

          {selectedMcqList?.length > 0 && (
            <Grid
              ref={offsetRef}
              sx={{
                display: "flex",
                flexWrap: "nowrap",
                listStyle: "none",
                overflow: "hidden",
                marginTop: "8px",
                height: "35px"
              }}
            >
              {getSelectedList(selectedMcqList, setSelectedMcqList)}
            </Grid>
          )}
          {showArrowMcq.right && (
            <IconButton size="small" sx={{ marginTop: "5px" }} onClick={() => onScrollHandle(100, setShowArrowMcq)}>
              <ScrollRight />
            </IconButton>
          )}
        </Grid>
        <Grid
          display="flex"
          flexDirection={"row"}
          flexWrap="wrap"
          container
          xs={12}
          overflow="hidden auto"
          maxHeight={isMobileScreen ? "400px" : "220px"}
          paddingTop="32px"
          marginBottom="8px"
          alignContent={"flex-start"}
          alignItems={"flex-start"}
          spacing={1}
          paddingRight="8px"
        >
          <Mcqlist
            list={showValue ? checkMcqList : checkMcqList?.slice(0, 8)}
            handleChange={handleChange}
            currQues={currQues}
            selectedList={selectedMcqList}
          />
        </Grid>
      </Grid>
    );
  };

  const filterMcqAnswerJSX = () => {
    const roleOptions = currQues?.filter?.map((element: any) => element);
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} display="flex" flexDirection="row" justifyContent="space-between">
          <Typography variant="body2" sx={{ marginTop: "16px" }}>
            Filter by
          </Typography>
          <MultipleSelectCheckmarks
            minWidth="104px"
            name="roleType"
            label="Role type"
            options={converter_ArrayString(roleOptions, "name")}
            onChange={(value: any) => filterList(value)}
          />
        </Grid>
        <Grid item xs={12} sx={{ display: "flex", flexWrap: "nowrap" }}>
          {showArrowFilterMcq.left && (
            <IconButton
              size="small"
              sx={{ marginTop: "5px" }}
              onClick={() => onScrollHandle(-100, setShowArrowFilterMcq)}
            >
              <ScrollLeft />
            </IconButton>
          )}

          {selectedFilterMcqList?.length > 0 && (
            <Grid
              item
              xs={12}
              ref={offsetRef}
              sx={{
                display: "flex",
                flexWrap: "nowrap",
                listStyle: "none",
                overflow: "hidden",
                marginTop: "8px",
                height: "35px"
              }}
            >
              {getSelectedList(selectedFilterMcqList, setSelectedFilterMcqList)}
            </Grid>
          )}
          {showArrowFilterMcq.right && (
            <IconButton
              size="small"
              sx={{ marginTop: "5px" }}
              onClick={() => onScrollHandle(100, setShowArrowFilterMcq)}
            >
              <ScrollRight />
            </IconButton>
          )}
        </Grid>

        <Grid
          container
          xs={12}
          overflow="hidden auto"
          height={isMobileScreen ? "400px" : "200px"}
          marginTop="8px"
          marginBottom="8px"
          paddingRight="8px"
          spacing={1}
          alignContent={"flex-start"}
          alignItems={"flex-start"}
        >
          <Mcqlist
            list={checkBoxList}
            handleChange={handleChange}
            currQues={currQues}
            selectedList={selectedFilterMcqList}
          />
        </Grid>
      </Grid>
    );
  };

  const rangeAnswerJSX = (options: any) => {
    return options.map((option: any, index: number) => {
      const marks = [
        {
          value: option.minRange,
          label: option.minRange
        },
        {
          value: option.maxRange,
          label: option.maxRange
        }
      ];
      return (
        <Slider
          key={option.minRange}
          valueLabelDisplay="auto"
          value={Number(allAnswers[currQues.quesId]) || 0}
          step={1}
          onChange={handleChange}
          marks={marks}
          min={option.minRange}
          max={option.maxRange}
        />
      );
    });
  };

  const renderAnswers = (type: any, options: any) => {
    switch (type) {
      case "SINGLE_CHOICE":
        return <>{optionAnswerJSX(options)}</>;
      case "MCQ":
        return <>{mcqAnswerJSX()}</>;
      case "FILTER_MCQ": {
        return <>{filterMcqAnswerJSX()}</>;
      }
      case "SCALE":
        return <>{rangeAnswerJSX(options)}</>;
      case "TEXT":
        return <>Work in Progress</>;
    }
  };

  const getQuestionData = async () => {
    let onboardingDetailsData: any = JSON.parse(JSON.stringify(onboardingDetails));

    onboardingDetailsData.updatedDate = null;
    onboardingDetailsData.createdDate = null;
    const modifiedResponse = onboardingDetailsData.questionnaire.map((question: any) => {
      question.options.forEach((option: any) => {
        if (isNull(option.isSelected)) {
          option.isSelected = "N";
          option.selectedValue = "";
        } else {
          option.isSelected = "Y";
        }
      });
      return question;
    });
    const onBoardingData: any = {
      innCode: innCode,
      wizardType: ON_BOARDING,
      payload: {}
    };

    onBoardingData.payload.questionnaire = modifiedResponse;
    onBoardingData.payload.id = 0;
    onBoardingData.payload.createdDate = null;
    onBoardingData.payload.createdBy = onboardingDetailsData.createdBy;
    onBoardingData.payload.updatedDate = null;
    onBoardingData.payload.wizard = onboardingDetailsData.wizard;
    await dispatch(updateOnboardingQueries(onBoardingData));
    await dispatch(fetchSuggestedPlansIdAsync({ innCode }));
  };

  return (
    <Grid container spacing={1} width="100%" display={"flex"} flexDirection="column" paddingX="16px">
      {retakeWizard && (
        <Grid item display="flex" justifyContent="flex-end">
          {" "}
          <IconButton
            onClick={() => {
              getQuestionData();
              dispatch(setShowOnboardingWizard(false));
              dispatch(setLoadPages(true));
              dispatch(librarySelectedTab(selectedTab));
              dispatch(setShowOnboardingWizardFromLibrary(false));
            }}
          >
            {" "}
            <CloseIcon />
          </IconButton>
        </Grid>
      )}
      <Grid item display="flex" flexDirection="row" width="100%">
        <Typography variant={"h5"} sx={{ marginTop: "20px" }}>
          {currQues.question}
        </Typography>
      </Grid>
      <Grid item width="100%">
        <FormGroup>{renderAnswers(currQues.questionType, currQues.options)}</FormGroup>
      </Grid>
      {currQues?.questionType === "MCQ" &&
        checkMcqList?.length > 8 &&
        selectedMcqList?.length < currQues?.options?.length && (
          <ButtonLink
            sx={{ color: tokens.Text.General.Color, textAlign: "left" }}
            text={showValue ? showText.showLess : showText.showMore}
            textVariant="body2"
            onClick={() => setShowValue((prev) => !prev)}
            underline="none"
          />
        )}
    </Grid>
  );
}

export default QnA;
